/* global Office */

export interface OutlookMailItem {
  subject: string;
  senderEmail: string;
  senderName: string;
  recipientEmails: string[];
  body: string;
  conversationId: string;
  dateTimeCreated: Date;
  internetMessageId: string;
  attachments: Office.AttachmentDetails[];
}

export async function getCurrentMailItem(): Promise<OutlookMailItem | null> {
  return new Promise((resolve) => {
    const item = Office.context.mailbox.item;
    if (!item) {
      resolve(null);
      return;
    }

    const senderEmail = item.from?.emailAddress || "";
    const senderName = item.from?.displayName || "";

    item.body.getAsync(Office.CoercionType.Html, (result) => {
      const body = result.status === Office.AsyncResultStatus.Succeeded ? result.value : "";
      const recipientEmails = (item.to || []).map(
        (r: Office.EmailAddressDetails) => r.emailAddress
      );

      resolve({
        subject: item.subject || "",
        senderEmail,
        senderName,
        recipientEmails,
        body,
        conversationId: item.conversationId || "",
        dateTimeCreated: item.dateTimeCreated || new Date(),
        internetMessageId: item.internetMessageId || "",
        attachments: item.attachments || [],
      });
    });
  });
}

export function getMailboxUserEmail(): string {
  return Office.context.mailbox.userProfile.emailAddress;
}

export function openCrmRecord(crmUrl: string, entityType: string, recordId: string) {
  const url = `${crmUrl}/main.aspx?etn=${entityType}&id=${recordId}&pagetype=entityrecord`;
  window.open(url, "_blank");
}

export function onItemChanged(callback: () => void) {
  Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, callback);
}
